export const routeActionsByStatus = {
  Unassigned: {
    disableAll: false,
    assign: true,
    reOptimize: true,
    editRoute: true,
    resetRoute: true,
    removeRoute: true,
    removeTask: true,
    printRoute: true,
    printLoadingSheet: true,
    printBillOfLading: true,
    downloadBillOfLading: true,
    updateResource: true,
    updateBranches: true,
    associateAgent: true,
    block: true,
    printIkea: true,
    manageAssistants: true,
    updateLogisticVehicle: true
  },
  Assigned: {
    disableAll: false,
    assign: true,
    reOptimize: false,
    editRoute: true,
    resetRoute: true,
    removeRoute: false,
    removeTask: false,
    printRoute: true,
    printLoadingSheet: true,
    printBillOfLading: true,
    downloadBillOfLading: true,
    updateResource: true,
    updateBranches: true,
    associateAgent: false,
    block: true,
    printIkea: true,
    manageAssistants: true,
    updateLogisticVehicle: true
  },
  Started: {
    disableAll: false,
    assign: true,
    reOptimize: false,
    editRoute: true,
    resetRoute: true,
    removeRoute: false,
    removeTask: false,
    printRoute: true,
    printLoadingSheet: true,
    printBillOfLading: true,
    downloadBillOfLading: true,
    updateResource: true,
    updateBranches: true,
    associateAgent: false,
    block: true,
    printIkea: true,
    manageAssistants: true,
    updateLogisticVehicle: true
  },
  CourierHeading: {
    disableAll: false,
    assign: true,
    reOptimize: false,
    editRoute: true,
    resetRoute: true,
    removeRoute: false,
    removeTask: false,
    printRoute: true,
    printLoadingSheet: true,
    printBillOfLading: true,
    downloadBillOfLading: true,
    updateResource: true,
    updateBranches: true,
    associateAgent: false,
    block: true,
    printIkea: true,
    manageAssistants: true,
    updateLogisticVehicle: true
  },
  Completed: {
    disableAll: true,
    assign: false,
    reOptimize: false,
    editRoute: false,
    resetRoute: false,
    removeRoute: false,
    removeTask: false,
    printRoute: true,
    printLoadingSheet: true,
    printBillOfLading: true,
    downloadBillOfLading: true,
    updateResource: false,
    updateBranches: false,
    associateAgent: false,
    block: false,
    printIkea: true,
    manageAssistants: true,
    updateLogisticVehicle: true
  },
  Canceled: {
    disableAll: true,
    assign: false,
    reOptimize: false,
    editRoute: false,
    resetRoute: false,
    removeRoute: false,
    removeTask: false,
    printRoute: true,
    printLoadingSheet: true,
    printBillOfLading: true,
    downloadBillOfLading: true,
    updateResource: false,
    updateBranches: false,
    associateAgent: false,
    block: false,
    printIkea: true,
    manageAssistants: true,
    updateLogisticVehicle: true
  },
  Deleted: {
    disableAll: true,
    assign: false,
    reOptimize: false,
    editRoute: false,
    resetRoute: false,
    removeRoute: false,
    removeTask: false,
    printRoute: false,
    printLoadingSheet: false,
    printBillOfLading: false,
    downloadBillOfLading: false,
    updateResource: false,
    updateBranches: false,
    associateAgent: false,
    block: false,
    printIkea: false,
    manageAssistants: false,
    updateLogisticVehicle: false
  }
};

export const autonomousRouteDisabledActions = ['disableAll', 'manageAssistants', 'updateLogisticVehicle', 'assign', 'reOptimize', 'editRoute',
  'resetRoute', 'removeRoute', 'removeTask', 'updateResource', 'updateBranches', 'updateBranches', 'block', 'mergeRoutes', 'sendToPlanning'];

